import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import ErrorBoundary from './components/global/ErrorBoundary';
import NotFound from './components/global/NotFound';
import { IntroRoute, UnprotectedRoute, ProtectedRoute } from './helpers/AuthRouter';
import FontLoader from './helpers/FontLoader';
import MessageProvider from './helpers/MessageProvider';
import NTRIPProvider from './helpers/NTRIPProvider';
import StoreProvider from './helpers/StoreProvider';
import ModalContainer from './libs/ModalContainer';
import { NotifierContainer } from './libs/Notifier';
import AuthCallback from './pages/auth/callback';
import ControlCenter from './pages/control-center';
import MissionHub from './pages/mission-hub';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<IntroRoute />} />
      <Route
        path="/auth/callback"
        element={
          <UnprotectedRoute>
            <AuthCallback />
          </UnprotectedRoute>
        }
      />
      <Route
        path="/control-center"
        element={
          <ProtectedRoute>
            <MessageProvider>
              <NTRIPProvider>
                <ModalContainer />
                <ControlCenter />
              </NTRIPProvider>
            </MessageProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="/mission-hub/:id?"
        element={
          <ProtectedRoute>
            <MessageProvider>
              <ModalContainer />
              <MissionHub />
            </MessageProvider>
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <FontLoader />
      <NotifierContainer />
      <StoreProvider>
        <ErrorBoundary>
          <AppRoutes />
        </ErrorBoundary>
      </StoreProvider>
    </BrowserRouter>
  );
};

export default App;
